import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BsModalService } from 'ngx-bootstrap/modal';

import { HelperService } from 'src/app/shared/helper.service';
import { ViewContractDashboard } from 'src/app/shared/models';
import { ContractSelectorModalComponent } from './contract-selector-modal/contract-selector-modal.component';

@Component({
	selector: 'pk-broker-contract-selector',
	templateUrl: './contract-selector.component.html',
	styleUrls: ['./contract-selector.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			useExisting: ContractSelectorComponent,
		},
	],
	standalone: false,
})
export class ContractSelectorComponent implements ControlValueAccessor {
	public contract: ViewContractDashboard = null;
	public inputId: string;

	public disabled = false;
	private touched = false;

	@Output() selection = new EventEmitter<ViewContractDashboard>();

	@Input()
	label = 'Contract';
	@Input()
	nullContractText = '-- None --';
	@Input()
	controlType: 'form' | 'filter' = 'form';
	@Input()
	initialValue: string;
	@Input()
	initialCriteria: any;

	constructor(private modalService: BsModalService) {
		this.inputId = HelperService.getUniqueId();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onChange = (_contract: ViewContractDashboard) => {
		/* placeholder for interface */
	};
	onTouched = () => {
		/* placeholder for interface */
	};

	showLookupContract() {
		const modalRef = this.modalService.show(ContractSelectorModalComponent, {
			class: 'pk-modal modal-xl',
			initialState: {
				initialValue: this.initialValue,
				initialCriteria: this.initialCriteria,
			},
		});
		modalRef.content.onSubmit.subscribe((contract: ViewContractDashboard) => {
			this.markAsTouched();
			this.contract = contract;
			this.onChange(this.contract);
			this.selection.emit(this.contract);
		});
	}

	public clearContract(): void {
		this.markAsTouched();
		this.contract = null;
		this.onChange(this.contract);
		this.selection.emit(this.contract);
	}

	writeValue(contract: ViewContractDashboard) {
		this.contract = contract;
	}

	registerOnChange(onChange: (contract: ViewContractDashboard) => void) {
		this.onChange = onChange;
	}

	registerOnTouched(onTouched: () => void) {
		this.onTouched = onTouched;
	}

	markAsTouched() {
		if (!this.touched) {
			this.onTouched();
			this.touched = true;
		}
	}

	setDisabledState(disabled: boolean) {
		this.disabled = disabled;
	}
}
